import api from 'base/utils/api';
import { ISeo } from 'base/interfacesV2/seo';

/**
 * 获取页面SEO配置
 * @param seoCode 后台 SEO 配置的唯一标识，在 pro/config/pages.ts 中配置
 * @param query url中的query数据，列表页、商品页还包含 [path] 变量解析后得到的参数
 */
export function getSeoConfig(seoCode: string, query: Record<string, any>): Promise<ISeo> {
    return api.post('/web/seo/config/query', {
        data: {
            pageCode: seoCode,
            query
        }
    });
}